import { useLocation } from "@Light/components/page/account";
import { useLight } from "@Light/services/light";
import { DocumentsSelectorItem } from "./DocumentsSelectorItem";
import { useScaffold } from "@Light/scaffold";
import { DocumentsSelectorLink } from "./DocumentsSelectorLink";
import clsx from "clsx";

export const DocumentsSelector: React.FC = () => {
  const { useGetAllLocationsDocumentsQuery } = useLight();
  const { uuid } = useLocation();
  const allDocuments = useGetAllLocationsDocumentsQuery({ uuid });
  const scaffold = useScaffold();
  const documents = allDocuments.data?.data;
  if (!documents) {
    return null;
  }

  const { termsOfServiceUrl } = scaffold.page;
  return (
    <div className="flex flex-col">
      {documents?.map((docSet) => (
        <DocumentsSelectorItem key={docSet.uuid} docSet={docSet} />
      ))}
      {termsOfServiceUrl && (
        <DocumentsSelectorLink to={"/account/documents/other"}>
          <div
            className={clsx(
              scaffold.page.colors.text.primary,
              "text-sm font-medium",
            )}
          >
            Other documents
          </div>
        </DocumentsSelectorLink>
      )}
    </div>
  );
};
